module.exports = __webpack_public_path__ + "static/media/html.eab3757b.png";